export const GOLDEN_RATIO = 1.61803
export const MAJOR_THIRD = 1.25
